import { useState } from 'react';
import Modal from 'react-responsive-modal';
import ListView from '../../../components/views/listView';

import { useQuestionHistorical } from '../historicalQuestion/hook';
import { QuestionHistoricalModalProps } from '../historicalQuestion/props';

export const QuestionHistoricalModal = ({
    historical,
    open,
    setOpen,
    loading,
}: QuestionHistoricalModalProps) => {
    const { columns, rows } = useQuestionHistorical(historical);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);

    const paginator = (paginationModel: { page: number; pageSize: number }) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const paginatedRows = rows.slice(page * pageSize, (page + 1) * pageSize);

    if (!open) return null;

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            animationDuration={0}
            styles={{ modal: { maxWidth: '800px', minWidth: '90%' } }}
        >
            <ListView
                columns={columns}
                rows={paginatedRows}
                rowCount={rows.length}
                onSetPage={paginator}
                loading={loading}
                disableAdd
                disableBack
            />
        </Modal>
    );
};
